export default __webpack_public_path__ + "img/visa-secure_blu_72dpi.084f88e7.jpg";